import clsx from "clsx";
import { Icon } from "../Icon";
import Mask from "../Mask";
import Modal from "../Modal";
import { motion, Variants } from "framer-motion";
import React, { useMemo, useState } from "react";
import { StrapiCmsMenuItem, StrapiCmsSiteMenu } from "../../queries/graphql";
import { LazyLinkToCategory } from "./lazylink";
import * as classes from "./mobileMenu.module.scss";
import { MobileMenuLeaf } from "./mobileMenuLeaf";
const HlIcon = new URL("../../assets/highlight.svg", import.meta.url);
const LogoIcon = new URL("../../assets/logo.svg", import.meta.url);
const ServicesIcon = new URL("../../assets/services.svg", import.meta.url);
const ExpandIcon = new URL("../../assets/expand.svg", import.meta.url);
const CollapseIcon = new URL("../../assets/collapse.svg", import.meta.url);
interface IComponentProps {
  menuData?: StrapiCmsSiteMenu;
  isOpen: boolean;
  closeModal: () => void;
}
//animation
const containerAnimationVariants: Variants = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
    },
  },
};

const listItemAnimationVariants: Variants = {
  hidden: { translateX: -10, opacity: 0 },
  show: { translateX: 0, opacity: 1 },
};
export const MobileMenu = (props: IComponentProps) => {
  const { menuData, isOpen, closeModal } = props;
  // useLockBodyScroll({ state: isOpen })
  const [tabIndex, setTabIndex] = useState<"men" | "women">("men");
  const [activeItem, setActiveItem] = useState<StrapiCmsMenuItem>();
  const [aboutCurnonExpanded, setAboutCurnonExpanded] = useState(false); //default to hide
  const currentMenuData = useMemo(() => {
    if (!menuData) {
      return false;
    }
    if (tabIndex == "men") {
      return menuData.MenMenu;
    }
    return menuData.WomenMenu;
  }, [menuData, tabIndex]);
  if (!currentMenuData) {
    return null;
  }
  return (
    <Modal>
      <motion.div
        initial={{ translateX: "-100vw", opacity: 0 }}
        variants={{
          open: {
            translateX: 0,
            opacity: 1,
          },
          closed: {
            translateX: "-100vw",
            opacity: 0,
          },
        }}
        transition={{ ease: "easeIn" }}
        className={classes.root}
        animate={isOpen ? "open" : "closed"}
      >
        {activeItem == undefined && (
          <motion.div className={classes.body} layoutId={"menu_body"}>
            <div className={classes.menuHeader}>
              <div
                className={clsx(classes.headerItem)}
                onClick={() => {
                  setTabIndex("men");
                }}
              >
                <span></span>
                <span>NAM GIỚI</span>
                {tabIndex == "men" && (
                  <motion.img
                    layoutId="bottomHl2"
                    className={classes.hlIcon}
                    alt="hl"
                    src={HlIcon.toString()}
                  ></motion.img>
                )}
              </div>
              <div className={classes.headerSpacer}></div>
              <div
                className={clsx(classes.headerItem)}
                onClick={() => {
                  setTabIndex("women");
                }}
              >
                <span></span>
                <span>NỮ GIỚI</span>
                {tabIndex == "women" && (
                  <motion.img
                    layoutId="bottomHl2"
                    className={classes.hlIcon}
                    alt="hl"
                    src={HlIcon.toString()}
                  ></motion.img>
                )}
              </div>
            </div>
            <div className={classes.menuSpacer}>
              <motion.div
                style={{
                  width: "50%",
                  height: 2,
                  background: "#000",
                  translateY: -1,
                }}
                variants={{
                  left: { translateX: 0 },
                  right: { translateX: "100%" },
                }}
                animate={tabIndex == "men" ? "left" : "right"}
                transition={{ type: "ease", duration: 0.4 }}
              ></motion.div>
            </div>

            <motion.div
              key={["body"].join("_")}
              // variants={containerAnimationVariants}
              // initial="hidden"
              // animate="show"
              className={classes.menuBody}
            >
              {currentMenuData.items
                .filter((el) => el.Visible)
                .sort((a, b) => a.RelativePosition - b.RelativePosition)
                .map((menuItem) => {
                  const directChildren = menuItem.menu_children.filter(
                    (el2) => el2.ShowUnderParent
                  );

                  return (
                    <motion.div
                      className={classes.menuItem}
                      key={menuItem.id}
                      // variants={listItemAnimationVariants}
                    >
                      <button
                        className={classes.menuItemTitle}
                        onClick={() => {
                          setActiveItem(menuItem);
                        }}
                      >
                        <motion.span layoutId={"menuItemTitle_" + menuItem.id}>
                          {menuItem.Title}
                        </motion.span>
                        <Icon
                          name="right"
                          classes={{ root: classes.menuRightIcon }}
                        />
                      </button>
                      {directChildren.length > 0 && (
                        <div className={classes.menuChildren}>
                          {directChildren.map((childItem) => {
                            return (
                              <div
                                key={childItem.id}
                                className={classes.menuChildItem}
                              >
                                {childItem.Title}
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </motion.div>
                  );
                })}
              <motion.div
                key={["bottom"].join("_")}
                className={classes.bottomNav}
              >
                {/* <motion.div variants={listItemAnimationVariants} className={classes.bottomNavItem}>
                  <AccountIcon></AccountIcon>
                  <span className={classes.bottomNavTitle}>TÀI KHOẢN</span>
                </motion.div> */}
                <motion.div
                  variants={listItemAnimationVariants}
                  className={classes.bottomNavItem}
                >
                  <img src={LogoIcon.toString()} />

                  <a href="/policies" className={classes.bottomNavTitle}>
                    <span>DỊCH VỤ KHÁCH HÀNG</span>
                  </a>
                </motion.div>
                <motion.div
                  className={classes.bottomNavItem}
                  onClick={() => {
                    setAboutCurnonExpanded((v) => !v);
                  }}
                >
                  <img src={LogoIcon.toString()} />

                  <span className={classes.bottomNavTitle}>VỀ CURNON</span>
                  {!aboutCurnonExpanded ? (
                    <img src={ExpandIcon.toString()} />
                  ) : (
                    <img src={CollapseIcon.toString()} />
                  )}
                </motion.div>
                <motion.div
                  className={classes.bottomNavItem}
                  variants={{ closed: { opacity: 0 }, open: { opacity: 1 } }}
                  animate={aboutCurnonExpanded ? "open" : "closed"}
                >
                  <span className={classes.bottomNavVerticalLine}></span>
                  <div className={classes.bottomNavItemList}>
                    <a href="/blog" className={classes.bottomNavItemListChild}>
                      Blog
                    </a>

                    <a href="/about" className={classes.bottomNavItemListChild}>
                      Về chúng tôi
                    </a>

                    <a
                      href="https://longandshort.vn"
                      className={classes.bottomNavItemListChild}
                    >
                      Long & Short
                    </a>
                  </div>
                </motion.div>
              </motion.div>
            </motion.div>
          </motion.div>
        )}
        {activeItem && (
          <motion.div className={classes.body} layoutId={"menu_body"}>
            <div className={classes.menuHeader}>
              <button
                className={classes.backBtn}
                onClick={() => {
                  setActiveItem(undefined);
                }}
              >
                <Icon name="left" classes={{ root: classes.iconleft }}></Icon>
                <motion.span
                  style={{ flex: 1 }}
                  layoutId={"menuItemTitle_" + activeItem.id}
                >
                  {activeItem.Title}
                </motion.span>
                <span style={{ visibility: "hidden", width: 24 }}></span>
              </button>
            </div>
            <div className={classes.menuSpacer}></div>
            <div className={classes.menuBodyLeaf}>
              <MobileMenuLeaf item={activeItem}></MobileMenuLeaf>
            </div>
            <div className={classes.menuFooter}>
              <div
                className={classes.menuSpacer}
                style={{ marginBottom: 16 }}
              ></div>
              <LazyLinkToCategory id={activeItem.CategoryId}>
                <a className={classes.menuFooterBtn} onClick={closeModal}>
                  Xem Tất Cả{" "}
                  <Icon
                    name="line_right"
                    classes={{ root: classes.menuItemIconRight }}
                  ></Icon>
                </a>
              </LazyLinkToCategory>
            </div>
          </motion.div>
        )}
        <button className={classes.closeBtn} onClick={closeModal}>
          <Icon name="cross" />
        </button>
      </motion.div>
      <Mask
        isActive={isOpen}
        classes={{
          root_active: classes.maskRootActive,
          root: classes.maskRoot,
        }}
        dismiss={closeModal}
      />
    </Modal>
  );
};
